import type { AalView } from "../aalV2";
import { useAalListQuery } from "../aalV2";

export type PromosAALTableFilters = {
  view: AalView;
  start_date: string;
  end_date: string;
  page?: number;
  size?: number;
  sort?: string;
  promo_type?: string;
  promo_status?: string;
  action_type?: string;
  agent_id?: string;
  agent_role_id?: string;
  username?: string;
};

export type PromosAALTableItem = {
  event_id: string;
  event_sort_key?: string;
  created_at: string;
  target_username: string;
  target_user_id: string;
  banner_title: string;
  braze_banner_msg?: string;
  promo_type: string;
  amount?: string | number | null;
  realized_value?: string | number | null;
  agent_email: string;
  agent_id: string;
  agent_role_id?: string;
  reason: string;
  status?: string;
  promo_status?: string;
  status_color?: string;
  time_claimed?: string | null;
  promo_time_granted?: string | null;
  promo_percentage?: string | number | null;
  amount_realized?: string | number | null;
};

export type PromosAALApvTableItem = {
  agent_id: string;
  agent_email: string;
  agent_role_id?: string;
  free_picks_amount?: number;
  free_picks_amount_pct_change?: number;
  free_picks_amount_realized?: number;
  free_picks_amount_realized_pct_change?: number;
  free_picks_given?: number;
  free_picks_given_pct_change?: number;
  profit_boosts_amount_realized?: number;
  profit_boosts_amount_realized_pct_change?: number;
  profit_boosts_given?: number;
  profit_boosts_given_pct_change?: number;
  free_spins_amount_realized?: number;
  free_spins_amount_realized_pct_change?: number;
  free_spins_given?: number;
  free_spins_given_pct_change?: number;
  claim_bonuss_amount?: number;
  claim_bonuss_amount_pct_change?: number;
  claim_bonuss_amount_realized?: number;
  claim_bonuss_amount_realized_pct_change?: number;
  claim_bonuss_given?: number;
  claim_bonuss_given_pct_change?: number;
};

export const useGetAALPromosTable = (filters: PromosAALTableFilters) => {
  const {
    view,
    start_date,
    end_date,
    page,
    size,
    sort,
    promo_type,
    promo_status,
    action_type,
    agent_id,
    agent_role_id,
    username,
  } = filters;

  const eqFilters =
    view === "events"
      ? {
          promo_type,
          promo_status,
          action_type,
          agent_id,
          agent_role_id,
          username,
        }
      : {
          promo_type,
          agent_id,
          agent_role_id,
          username,
        };

  return useAalListQuery<PromosAALTableItem | PromosAALApvTableItem>(
    "promos",
    view,
    {
      start_date,
      end_date,
      page,
      size,
      sort,
      filters: eqFilters,
    },
  );
};
